
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBeaconTowerSphere as ObiBeaconTowerSphereElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-beacon-tower-sphere.js';
 
 
 

 
 export const ObiBeaconTowerSphere = createComponent({
   react: React,
   tagName: 'obi-beacon-tower-sphere',
   elementClass: ObiBeaconTowerSphereElement,
   events: {
     
   }
  });
 
 